import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "universal-cookie";

export const getBasePath = (state: any): string => {
  const { companyId, marketplaceName } = state.app;
  if (!companyId || !marketplaceName) {
    throw new Error(
      "Company ID or Marketplace Name not available in Redux store"
    );
  }
  return `/${companyId}/${marketplaceName}`;
};

export const getAdminPath = (state: any): string => {
  const { companyId } = state.app;
  if (!companyId) {
    throw new Error("Company ID not available in Redux store");
  }
  return `/${companyId}`;
};

export const BasePath = (store: any): string => {
  return getBasePath(store.getState());
};

export const adminPath = (store: any): string => {
  return getAdminPath(store.getState());
};

export const customBaseQuery = fetchBaseQuery({
  baseUrl: process.env.NEXT_PUBLIC_BaseURL,
  prepareHeaders: (headers) => {
    const cookies = new Cookies();
    // const token = cookies.get("token");
    // if (token) {
    //   headers.set("Authorization", `Bearer ${token}`);
    // }
    // return headers;
    const token =
      cookies.get("inner_token") ||
      cookies.get("token");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

export const marketPlaceBaseQueryWrapper = async (
  args: any,
  api: any,
  extraOptions: any
) => {
  const state = api.getState() as any;
  const dynamicPath = getBasePath(state);

  // Automatically prefix dynamic path to all query URLs
  if (typeof args === "string") {
    return customBaseQuery(dynamicPath + args, api, extraOptions);
  } else if (typeof args === "object" && args.url) {
    return customBaseQuery(
      {
        ...args,
        url: dynamicPath + args.url,
      },
      api,
      extraOptions
    );
  }
  return customBaseQuery(args, api, extraOptions);
};

export const adminBaseQueryWrapper = async (
  args: any,
  api: any,
  extraOptions: any
) => {
  const state = api.getState() as any;
  const dynamicPath = getAdminPath(state);

  // Automatically prefix dynamic path to all query URLs
  if (typeof args === "string") {
    return customBaseQuery(dynamicPath + args, api, extraOptions);
  } else if (typeof args === "object" && args.url) {
    return customBaseQuery(
      {
        ...args,
        url: dynamicPath + args.url,
      },
      api,
      extraOptions
    );
  }
  return customBaseQuery(args, api, extraOptions);
};
